import "./PreviewSectionImage.css";
import { AnimatePresence, motion } from "framer-motion";
import React from "react";

interface Props {
    onMouseEnter: React.MouseEventHandler<HTMLDivElement> | undefined;
    onMouseLeave: React.MouseEventHandler<HTMLDivElement> | undefined;
    title: string;
    date: string;
    imagePath: string;
}
const variants = {
    visible: { opacity: 1, y: 0 },
    hidden: { opacity: 0, y: 100 }
}

const hoverVariants = {
    visible: { opacity: 1 },
    hidden: { opacity: 0 }
}

const focusVariants = {
    visible: { opacity: 1 },
    hidden: { opacity: 0 }
}

export default function PreviewSectionImage({ onMouseEnter, onMouseLeave, title, date, imagePath }: Props) {
    const [isFocused, setFocused] = React.useState(false);

    var divStyle = {
        backgroundImage: 'url("images/portfolio/' + imagePath + '")',
        height: "40rem",
        backgroundColor: "beige",
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        borderRadius: "20px",
        margin: "3rem 10% 0 10%"
    }

    return (
        <>
            <AnimatePresence>
                {
                    isFocused && <motion.div onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} className="focus-container" variants={focusVariants} initial="hidden" animate="visible" exit="hidden" onClick={() => { setFocused(false); }} transition={{ ease: [0.1, 0.25, 0.3, 1], duration: 0.5 }}>
                        <div className="image-box">
                            <img src={"images/portfolio/" + imagePath} alt={title} />
                        </div>
                    </motion.div>
                }
            </AnimatePresence>
            <motion.div
                variants={variants}
                initial="hidden"
                whileInView="visible"
                transition={{ ease: [0.1, 0.25, 0.3, 1], duration: 1 }}
                viewport={{ margin: "15% 0% -10% 0%" }}
            >
                <div className="info-section" style={divStyle}
                    onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
                    <motion.div variants={hoverVariants} className="hover-wrapper" initial="hidden" whileHover="visible" onClick={() => { setFocused(true) }} transition={{ ease: [0.1, 0.25, 0.3, 1], duration: 0.5 }}>
                        <div className="info-wrapper">
                            <div className="description-wrapper">
                                <h1>{title}</h1>
                                <h2>{date}</h2>
                            </div>
                        </div>
                    </motion.div>
                </div>
            </motion.div>
        </>
    );
}